import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CmsConfig, FeaturesConfigModule, I18nModule, UrlModule, ConfigModule } from '@spartacus/core';
import {
  IconModule,
  ItemCounterModule,
  KeyboardFocusModule,
  PromotionsModule,
  SpinnerModule
} from '@spartacus/storefront';
import { UigAddToCartComponent } from './uig-add-to-cart.component';
import { UigAddedToCartDialogComponent } from './uig-added-to-cart-dialog/uig-added-to-cart-dialog.component';
import { UigAddToWishlistModule } from '../../uig-product/uig-add-to-wishlist/uig-add-to-wishlist.module';
import { UigCartSharedModule } from '../uig-cart-shared/uig-cart-shared.module';
import { UigOccCartEntryAdapter } from '../uig-occ-cart-entry.adapter';
import { UigCartNotesModule } from '../uig-cart-notes/uig-cart-notes.module';
import {CartEntryAdapter} from '@spartacus/cart/base/core';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    SpinnerModule,
    PromotionsModule,
    FeaturesConfigModule,
    UrlModule,
    IconModule,
    I18nModule,
    ItemCounterModule,
    KeyboardFocusModule,
    UigCartSharedModule,
    UigAddToWishlistModule,
    UigCartNotesModule,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        ProductAddToCartComponent: {
          component: UigAddToCartComponent,
          data: {
            inventoryDisplay: false,
          },
        },
      },
    })
  ],
  declarations: [UigAddToCartComponent, UigAddedToCartDialogComponent],
  exports: [UigAddToCartComponent, UigAddedToCartDialogComponent],
  providers: [
    {
      provide: CartEntryAdapter,
      useClass: UigOccCartEntryAdapter,
    }
  ]
})
export class UigAddToCartModule { }
